export default __webpack_public_path__ + "static/media/foodCan.e835c57b.svg";